import axios from "axios";
import { API_URL } from "config";
import fileDownload from "js-file-download";
import moment from "moment";
import { useCentralStore } from "stores";
import { getToken } from "utils/getToken";
import { QueryBuilder } from "../utils/queryBuilder";

export const exportProfile = ({ type, churchId, id, format, orientation }) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.append("format", format);
  queryBuilder.append("orientation", orientation);

  const queryString = queryBuilder.build();

  let url = "";
  if (type === "member") {
    url = `${API_URL}/churches/${churchId}/members/${id}/export${queryString}`;
  } else if (type === "kid") {
    url = `${API_URL}/churches/${churchId}/children/${id}/export${queryString}`;
  } else if (type === "partner") {
    url = `${API_URL}/churches/${churchId}/partners/${id}/export${queryString}`;
  }

  axios({
    method: "get",
    url: url,
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  })
    .then(response => {
      fileDownload(
        new Blob([response.data]),
        `${type}_${moment().format("DD-MM-YYYY-hh-mm-A")}.${format}`
      );
    })
    .catch(() => {
      const setNotification = useCentralStore.getState().setNotification;
      setNotification({ type: "error", message: "Unable to export data" });
    });
};
